import { Box, Typography } from '@mui/material';

export const LegalSection = ({ title, children }) => (
	<Box component="section" sx={{ mb: 3.5 }}>
		<Typography
			variant="h6"
			component="h2"
			sx={{ fontWeight: 600, mb: 1.5, fontSize: '1.1rem' }}
		>
			{title}
		</Typography>
		{children}
	</Box>
);

export const LegalParagraph = ({ children }) => (
	<Typography
		variant="body1"
		color="text.secondary"
		sx={{ lineHeight: 1.8, mb: 1.5 }}
	>
		{children}
	</Typography>
);

export const LegalList = ({ items }) => (
	<Box component="ul" sx={{ pl: 2.5, m: 0, mb: 1.5, color: 'text.secondary' }}>
		{items.map((item) => (
			<Typography
				key={item}
				component="li"
				variant="body1"
				sx={{ lineHeight: 1.8, mb: 0.5 }}
			>
				{item}
			</Typography>
		))}
	</Box>
);

export const LegalEffectiveDate = () => (
	<Typography
		variant="body2"
		color="text.secondary"
		sx={{ mb: 3, fontStyle: 'italic' }}
	>
		Effective date: August 28, 2026
	</Typography>
);

export const LegalContact = ({ subject = 'Legal inquiry' }) => (
	<LegalParagraph>
		Questions? Email{' '}
		<Typography
			component="a"
			href={`mailto:management@bidzbase.com?subject=${encodeURIComponent(subject)}`}
			color="primary"
		>
			management@bidzbase.com
		</Typography>
		.
	</LegalParagraph>
);
